import translations from './translations.json';

/**
 * Returns the message map for the given locale.
 *
 * Always starts from English and layers the requested locale (and any base
 * locale, for regionals like en-GB) on top. A naive `translations[locale]`
 * lookup is insufficient because non-English snapshots drift: any key added
 * to en after the snapshot was taken would surface as a react-intl
 * MISSING_TRANSLATION error in fr/en-GB/etc., even though Rails I18n.fallbacks
 * resolves it on the server.
 *
 * Merge order: en → base locale → regional override. Later layers win on
 * conflict. Mirrors Rails I18n.fallbacks behaviour on the frontend.
 */
export default function getMessages(locale) {
  const en = translations.en || {};

  if (!locale || locale === 'en') return en;

  const base = locale.split('-')[0];
  const baseMessages = translations[base] || {};
  const override = base === locale ? null : translations[locale];

  return { ...en, ...baseMessages, ...(override || {}) };
}
